import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Wallet } from '../models/walletmodel';
import { WalletSearch } from '../models/walletsearchmodel';
import { Observable } from 'rxjs/Rx';
import { SharedService } from '../services/sharedservices.service';
import { config } from '../config/config';
import * as CryptoJS from 'crypto-js';
import {Search} from '../models/searchmodel';

@Injectable()
export class walletService {
  //authconfig: string = config.username + ':' + config.password;
  urlbase: string = config.baseUrl + 'wallet';

  constructor(private http: Http, private sharedservice: SharedService) { }

  /*createAuthorizationHeader(headers: Headers) {
    let conversionSessionOutput = CryptoJS.AES.decrypt(localStorage.getItem("access_token"), config.key).toString(CryptoJS.enc.Utf8);
    let authconfig = this.sharedservice.session.account_username + ':' + conversionSessionOutput;
    headers.append('Authorization', 'Basic ' +
      btoa(authconfig));
  }*/

  searchWalletTransaction(search: WalletSearch): Observable<Wallet[]> {
    const headers = new Headers();

    if (!this.sharedservice.isAdmin() && !this.sharedservice.isViewer()) {
      if (this.sharedservice.isMerchant()) {
        search.searchstoreid = this.sharedservice.session.account_username;
      }
      else {
        search.searchstoreid = this.sharedservice.session.account_userstore;
      }
    }

    const data = JSON.stringify(search);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.urlbase + '/search', data, {
      headers: headers,
      withCredentials: true
    }).map(res => res.json()).catch(this.handleError);
  }

  getLast10WalletTransactions(): Observable<Wallet[]> {
    var url;
    const headers = new Headers();

    if (this.sharedservice.isAdmin())
      url = this.urlbase + "/last";
    else if (this.sharedservice.isViewer())
      url = this.urlbase + "/last";
    else if (this.sharedservice.isMerchant())
      url = this.urlbase + "/last/auth";
    else
      url = this.urlbase + "/last/auth";

    // this.createAuthorizationHeader(headers);
    return this.http.get(url, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      let body: any;
      try {
        body = error.json();
      } catch (e) {
        body = null;
      }

      const err = (body && body.error) ? JSON.stringify(body) : error.statusText;
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/services/wallet.service.ts